import { createContext, Dispatch, MutableRefObject, ReactNode, SetStateAction, useContext, useRef, useState } from 'react';

type KeVatTuContextProps = {
	treeNodeValue: any[];
	setTreeNodeValue: Dispatch<SetStateAction<object[]>>;
	vatTuChecked: any[];
	setVatTuChecked: Dispatch<SetStateAction<any[]>>;
	treeValue: any;
	setTreeValue: Dispatch<SetStateAction<any>>;
	deletedList: Map<string, any>;
	setDeletedList: (key: string, value: any) => void;
	phieuDieuTri: any;
	isEdit: boolean;
	setIsEdit: Dispatch<SetStateAction<boolean>>;
	selectedNode: any;
	setSelectedNode: (data: any) => void;
};

const initialContextValue: KeVatTuContextProps = {
	vatTuChecked: [],
	setVatTuChecked() {},
	treeNodeValue: [],
	setTreeNodeValue() {},
	treeValue: {},
	setTreeValue() {},
	deletedList: new Map(),
	setDeletedList() {},
	phieuDieuTri: {},
	isEdit: false,
	setIsEdit() {},
	selectedNode: null,
	setSelectedNode() {},
};

const KeVatTuContext = createContext<KeVatTuContextProps>(initialContextValue);

export const KeVatTuContextProvider = ({ children, phieuDieuTri }: { children: ReactNode, phieuDieuTri: any }) => {
	const [vatTuChecked, setVatTuChecked] = useState<any[]>([]);
	const [treeValue, setTreeValue] = useState<any>();
	const [treeNodeValue, setTreeNodeValue] = useState<object[]>([]);
	const deletedListRef = useRef<Map<string, any>>(new Map());
	const [isEdit, setIsEdit] = useState<boolean>(false);

	const selectedNodeRef = useRef<any>();

	const setSelectedNode = (data: any) => {
		selectedNodeRef.current = data;
	};

	const setDeletedList = (key: string, value: any) => {
		if(!deletedListRef.current.has(key)) {
			deletedListRef.current.set(key, value);
		}
	};

	return (
		<KeVatTuContext.Provider
			value={{
				vatTuChecked,
				setVatTuChecked,
				treeNodeValue,
				setTreeNodeValue,
				treeValue,
				setTreeValue,
				deletedList: deletedListRef.current,
				setDeletedList,
				phieuDieuTri,
				isEdit,
				setIsEdit,
				selectedNode: selectedNodeRef.current,
				setSelectedNode,
			}}
		>
			{children}
		</KeVatTuContext.Provider>
	);
};

export const useKeVatTuContext = () => useContext<KeVatTuContextProps>(KeVatTuContext);
